import { optionalWeightedAvg, sum, weightedAvg } from "../shared";

export const aggregateAvgPrice = (rows) =>
  weightedAvg(rows, (row) => row.avgPrice, (row) => row.soldUnits);

export const aggregateMarkup = (rows, convert) => {
  const margin = optionalWeightedAvg(rows, (row) => convert(row.marginPercent), (row) => row.realized);
  return margin !== null && margin < 1 ? margin / (1 - margin) : null;
};

export const aggregateMarkdown = (rows, convert) =>
  optionalWeightedAvg(rows, (row) => convert(row.markdownPercent), (row) => row.realized);